import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import { usePqrHistoryFilters } from './hook';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { PqrHistoryFiltersProps } from './props';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';

export const PqrHistoryFilters = ({
    onFilter,
    loading,
}: PqrHistoryFiltersProps) => {
    const { formik, status, reconsiderations } = usePqrHistoryFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="PQR ID"
                    name="pqrId"
                    size="small"
                    touched={formik.touched.pqrId}
                    errors={formik.errors.pqrId}
                    value={formik.values.pqrId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} md={8}>
                <FieldText
                    label="Nombre / Razón social"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Identificación"
                    name="document"
                    size="small"
                    touched={formik.touched.document}
                    errors={formik.errors.document}
                    value={formik.values.document}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={reconsiderations}
                    label="Reconsideración"
                    name="reconsideration"
                    size="small"
                    defineValue="value"
                    touched={formik.touched.reconsideration}
                    errors={formik.errors.reconsideration}
                    value={formik.values.reconsideration as string[]}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('reconsideration', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={status}
                    label="Estado"
                    name="status"
                    size="small"
                    defineValue="value"
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string[]}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('status', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Placa"
                    name="plate"
                    size="small"
                    touched={formik.touched.plate}
                    errors={formik.errors.plate}
                    value={formik.values.plate}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Póliza"
                    name="policy"
                    size="small"
                    touched={formik.touched.policy}
                    errors={formik.errors.policy}
                    value={formik.values.policy}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Radicado de correspondencia"
                    name="correspondenceFiling"
                    size="small"
                    touched={formik.touched.policy}
                    errors={formik.errors.policy}
                    value={formik.values.correspondenceFiling}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
